<template>
    <div class="login-background">
      <div class="container panel-container-padding">
         <div class="panel shadow border-0 panel-round login-animate">
            <div class="panel-container">
               <div class="row no-gutters">
                  <div class="col-md-6 col-lg-4 col-xl-5 login-padding logo-container">
                     <div class="position-relative">
                        <div class="text-center">
                           <img class="img-fluid logo-image" src="@/assets/image/tunai.png"/>
                           <h2 class="h3 fw-500 text-center mt-3">Welcome to Tunai</h2>
                        </div>
                     </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-8 col-xl-7 ml-auto login-padding" style="padding-bottom: 0 !important;">
                     <form @submit.prevent="doLogin">
                        <h2 class="h1 fw-500 mb-4">Sign into your account</h2>
                        <div class="form-group">
                           <label class="form-label" for="loginUsername">Username</label>
                           <div class="input-group">
                              <span class="login-input-icon">
                              <i class="fas fa-user-alt width-1 text-align-center"></i>
                              </span>
                              <input type="text" class="form-control" v-model="loginUsername" @focus="errorLogin = false" id="loginUsername" name="loginUsername" placeholder="Username" aria-describedby="inputGroupPrepend" required="">
                           </div>
                        </div>
                        <div class="form-group mb-0">
                           <label class="form-label" for="loginPassword">Password</label>
                           <div class="input-group">
                              <span class="login-input-icon">
                              <i class="fas fa-lock width-1 text-align-center"></i>
                              </span>
                              <input :type="confirmType" class="form-control" v-model="loginPassword" @focus="errorLogin = false" id="loginPassword" name="loginPassword" placeholder="Password" aria-describedby="inputGroupPrepend" required="">
                              <a class="show-password-icon link" @click="confirmType = confirmType == 'password' ? 'text' : 'password'">
                                 <i class="fas" :class="confirmType == 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                              </a>
                           </div>
                        </div>
                        <div class="loginErrorContainer" v-if="errorLogin">Invalid login credential.</div>
                        <div class="mt-2 mb-5">
                           <router-link to="/forgotPassword" class="text-secondary fw-500" title="Forgot Password">Forgot Passsword</router-link>
                        </div>
                        <div class="text-left mb-5">
                           <button type="submit" class="btn border-0 btn-dark btn-padding waves-effect waves-themed">Login</button>
                        </div>
                     </form>
                     <div class="row">
                        <div class="col-md-7 col-sm-12 pl-0 pr-0">
                           <p>
                              <small>Contact customer support at
                                 <span class="text-primary fw-500">+60129699748</span>
                              </small>
                           </p>
                        </div>
                        <div class="col-md-5 col-sm-12 pl-0 pr-0 text-right">
                           <p>
                              <small><strong>Copyright</strong> JulyTech © 2018</small>
                           </p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Login',
  data: () => ({
      loginUsername: '',
      loginPassword: '',
      errorLogin: false,
      confirmType: 'password'
    }),
  methods: {
    doLogin () {
      let $vm = this;
      var data = {
         username: this.loginUsername,
         password: this.loginPassword   
      }
      this.$axios({
            method: 'post', 
            url: this.$api.LOGIN,
            baseURL: this.$axios.defaults.baseURL, 
            data: data,
      })
      .then((response) => {
         if(response.status == 200){
            this.$session.start();
            this.$session.set('token', response.data.token);
            var data = response.data;
            Object.assign(data, {userName: this.loginUsername});

            localStorage.setItem('token', response.data.token)
            localStorage.setItem('userName', this.loginUsername)

            $vm.$store.commit('LOGIN_SUCCESS', data);
            // this.$router.push({ name: 'dashboard_info' });
            if(data.block.indexOf("biz.report.*") == -1){
               // this.$router.push({ name: 'salon_report_sales' });
               // this.$router.push({ name: 'salon_report_payment' });
               // this.$router.push({ name: 'salon_report_sales' });
               this.$router.push({ name: 'salon_report_commission' });
            }
            else if(data.block.indexOf("biz.dashboard.view") !== 1){
               this.$router.push({ path: 'dashboard/my_salon_appointment' })
            }else{
               this.$router.push({ name: 'dashboard_info2' });
               // this.$router.push({ name: 'dashboard_info' });
            }
            
         }
         
      })
      .catch(() => {
        this.errorLogin = true;
        })
    }
  }
}
</script>

<style src="@/assets/css/login.css" scoped></style>
<style scoped>
.show-password-icon{
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 99999;
}
</style>